import type { AppRouteRecordRaw } from '@/router/types'

/**
 * 紫金餐厅（代客点餐收银系统）独立路由组
 *
 * 由 AnKeFood-DaiKeVue（Vue2 收银系统）迁移复刻而来：
 * - 不走 yudao 默认 Layout，全屏独立运行
 * - 与主平台同进程同源，共享 localStorage 中的 yudao 登录态
 * - 后端复用美食餐饮（fuint）backendApi / clientApi 接口
 *
 * 路由路径前缀：/cash/*
 * 文件名 = 后端 system_module.name = 'daike'，与热插拔过滤逻辑完全一致
 */
const daikeAppRoutes: AppRouteRecordRaw[] = [
  {
    path: '/cash',
    component: () => import('@/views/daike-app/layout/index.vue'),
    redirect: '/cash/home',
    name: 'DaikeAppRoot',
    meta: { title: '紫金餐厅', hidden: true },
    children: [
      {
        path: 'home',
        component: () => import('@/views/daike-app/home/index.vue'),
        name: 'DaikeAppHome',
        meta: { title: '系统首页', hidden: true }
      },
      {
        path: 'cashier',
        component: () => import('@/views/daike-app/cashier/index.vue'),
        name: 'DaikeAppCashier',
        meta: { title: '收银台', hidden: true }
      },
      {
        path: 'setting',
        component: () => import('@/views/daike-app/setting/index.vue'),
        name: 'DaikeAppSetting',
        meta: { title: '系统设置', hidden: true }
      }
    ]
  }
]

export default daikeAppRoutes
